import { render, staticRenderFns } from "./HighlightEdit.vue?vue&type=template&id=05291838"
import script from "./HighlightEdit.vue?vue&type=script&lang=ts"
export * from "./HighlightEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05291838')) {
      api.createRecord('05291838', component.options)
    } else {
      api.reload('05291838', component.options)
    }
    module.hot.accept("./HighlightEdit.vue?vue&type=template&id=05291838", function () {
      api.rerender('05291838', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/view-editor/HighlightEdit.vue"
export default component.exports